import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import CreatableSelect from "react-select/creatable"; 
import Select from "react-select";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { isPurchaseUser } from "../utils/permissions";
import { components } from "react-select";
import { authFetch } from "../utils/authFetch";

const API = process.env.REACT_APP_API_URL;

const Icon = {
  search: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>,
  plus: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5v14"/></svg>,
  edit: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>,
  trash: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/></svg>,
  history: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l4 2"/></svg>,
  pdf: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M12 18v-6M9 15l3 3 3-3"/></svg>,
  excel: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M8 13h2l2 3 2-3h2"/></svg>,
  building: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="16" height="20" x="4" y="2" rx="2"/><path d="M9 22v-4h6v4M8 6h.01M16 6h.01M12 6h.01M12 10h.01M12 14h.01M16 10h.01M16 14h.01M8 10h.01M8 14h.01"/></svg>,
  close: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>,
  sun: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>,
  moon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"/></svg>,
  chevL: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>,
  chevR: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg>,
  phone: <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>,
  mail: <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-10 5L2 7"/></svg>,
  pin: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 7-8 13-8 13s-8-6-8-13a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>,
  save: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z"/><path d="M17 21v-8H7v8M7 3v5h8"/></svg>,
};

const defaultSources = [
  { value: "Referral", label: "Referral" },
  { value: "Cold Call", label: "Cold Call" },
  { value: "Website", label: "Website" },
  { value: "Exhibition", label: "Exhibition" },
  { value: "Google Search", label: "Google Search" },
  { value: "Existing Database", label: "Existing Database" },
];

const emptyForm = {
  name: "", gst_no: "", contact_person: "", contact_number: "",
  email: "", department: "", categories: [], sub_category: "", source: "", 
  address_line1: "", address_line2: "", address_line3: "",
};
const CategoryOption = (props) => {
  const { data } = props;

  return (
    <components.Option {...props}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <span>{data.label}</span>

        <span
          onClick={async (e) => {
            e.stopPropagation();

            if (!window.confirm(`Delete ${data.label}?`))
              return;

            try {
              await authFetch(
                `${API}/api/master/categories/${data.id}`,
                {
                  method: "DELETE"
                }
              );

              alert("Category Deleted");

            } catch {
              alert("Delete Failed");
            }
          }}
          style={{
            color: "red",
            cursor: "pointer",
            fontWeight: "bold"
          }}
        >
          🗑
        </span>
      </div>
    </components.Option>
  );
};
const DepartmentOption = (props) => {
  const { data } = props;

  return (
    <components.Option {...props}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <span>{data.label}</span>

        <span
          onClick={async (e) => {
            e.stopPropagation();

            if (!window.confirm(`Delete ${data.label}?`))
              return;

            await authFetch(
              `${API}/api/master/departments/${data.id}`,
              { method: "DELETE" }
            );

            window.location.reload();
          }}
          style={{
            color: "#dc2626",
            cursor: "pointer",
            fontSize: 16,
            fontWeight: 700
          }}
        >
          🗑
        </span>
      </div>
    </components.Option>
  );
};

function VendorsPage() {
  const [form, setForm] = useState(emptyForm);
  const [vendors, setVendors] = useState([]);
  
  // DYNAMIC MASTER ARRAY STATES (Now stores raw database schemas)
  const [masterDepartments, setMasterDepartments] = useState([]);
  const [masterCategories, setMasterCategories] = useState([]);
  const [masterSubCategories, setMasterSubCategories] = useState([]);
  const [sources, setSources] = useState(defaultSources);

  const [search, setSearch] = useState("");
  const [selectedDeptFilter, setSelectedDeptFilter] = useState(null);
  const [selectedCategoryFilter, setSelectedCategoryFilter] = useState(null); 
  const [selectedSourceFilter, setSelectedSourceFilter] = useState(null); 
  const [currentPage, setCurrentPage] = useState(1);
  const [editingId, setEditingId] = useState(null);
  const [summary, setSummary] = useState(null);
  const [summaryVendor, setSummaryVendor] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [toast, setToast] = useState(null);
  const [confirmDel, setConfirmDel] = useState(null);
  const [searchParams] = useSearchParams();
  const [dark, setDark] = useState(
    typeof window !== "undefined" && localStorage.getItem("vp-theme") === "dark"
  );

  const itemsPerPage = 8;

  const t = dark
  ? {
      bg: "#111827", surface: "rgba(31,41,55,0.75)", card: "#1f2937",
      border: "#374151", borderSoft: "#2b3545", text: "#f9fafb",
      textMuted: "#9ca3af", textFaint: "#6b7280", chip: "#374151",
      chipText: "#f3f4f6", rowHover: "rgba(55,65,81,0.4)", inputBg: "#1f2937",
      primary: "#f9fafb", primaryText: "#111827", danger: "#f43f5e", success: "#10b981",
    }
  : {
      bg: "#f3f4f6", surface: "rgba(255,255,255,0.78)", card: "#ffffff",
      border: "#e5e7eb", borderSoft: "#f3f4f6", text: "#111827",
      textMuted: "#6b7280", textFaint: "#9ca3af", chip: "#f3f4f6",
      chipText: "#374151", rowHover: "#f9fafb", inputBg: "#ffffff",
      primary: "#111827", primaryText: "#ffffff", danger: "#e11d48", success: "#059669",
    };

  useEffect(() => {
    localStorage.setItem("vp-theme", dark ? "dark" : "light");
    document.body.style.background = t.bg;
    document.body.style.color = t.text;
  }, [dark, t.bg, t.text]);

  const pushToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 2600);
  };

  // FETCH MASTER CONFIG LISTS (Loads raw objects for cleaner mapping lookup handles)
  const loadMasterLists = async () => {
    try {
      const [deptRes, catRes, subRes] = await Promise.all([
         authFetch(`${API}/api/master/departments`),
         authFetch(`${API}/api/master/categories`),
         authFetch(`${API}/api/master/sub-categories`)
        ]);
      
      const depts = await deptRes.json();
      const cats = await catRes.json();
      const subs = await subRes.json();

      setMasterDepartments(depts); 
      setMasterCategories(cats);
      setMasterSubCategories(subs); 
    } catch {
      pushToast("Could not retrieve synchronization lists.", "error");
    }
  };

  const loadVendors = async () => {
    try {
      const res = await authFetch(`${API}/vendors`);
      const data = await res.json();
      const loadedVendors = Array.isArray(data) ? data : [];
      setVendors(loadedVendors);

      const uniqueVendorSources = new Set(loadedVendors.map((v) => v.source).filter(Boolean));
      setSources((prev) => {
        const existingVals = new Set(prev.map(s => s.value));
        const merged = [...prev];
        uniqueVendorSources.forEach(src => {
          if (!existingVals.has(src)) {
            merged.push({ value: src, label: src });
          }
        });
        return merged;
      });
    } catch {
      pushToast("Could not reach server", "error");
    }
  };

  useEffect(() => { 
    loadMasterLists();
    loadVendors(); 
  }, []);

  // 1. FILTER CATEGORY DROPDOWN OPTIONS BY SELECTED FORM DEPARTMENT
  const dynamicCategoryFormOptions = useMemo(() => {
    if (!form.department) return [];
    return masterCategories
      .filter(c => c.department?.toLowerCase() === form.department.toLowerCase())
      .map(c => ({
  id: c.id,
  value: c.name,
  label: c.name
}));
  }, [form.department, masterCategories]);

  // 2. FIXED SUB-CATEGORY DROPDOWN OPTIONS LOOKUP (Fixed string value comparison array bug)
  const dynamicSubCategoryOptions = useMemo(() => {
    if (!form.categories || form.categories.length === 0) return [];
    
    // Find the master list IDs of all selected text strings
    const selectedCatIds = masterCategories
      .filter(c => form.categories.includes(c.name))
      .map(c => c.id);

    return masterSubCategories
      .filter(sub => selectedCatIds.includes(sub.category_id))
      .map(sub => ({ value: sub.name, label: sub.name }));
  }, [form.categories, masterCategories, masterSubCategories]);

  // 3. FILTER CATEGORY OPTIONS FOR FOOTER TABLE FILTER
  const dynamicCategoryFilterOptions = useMemo(() => {
    let list = masterCategories;
    if (selectedDeptFilter) {
      list = list.filter(c => c.department?.toLowerCase() === selectedDeptFilter.value.toLowerCase());
    }
    return list.map(c => ({ value: c.name, label: c.name }));
  }, [selectedDeptFilter, masterCategories]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const resetForm = () => { setForm(emptyForm); setEditingId(null); };

  const deleteDepartment = async () => {
  if (!form.department) {
    pushToast("Select a department first", "error");
    return;
  }

  const dept = masterDepartments.find(
    d => d.name === form.department
  );

  if (!dept) return;

  if (!window.confirm(`Delete Department "${dept.name}" ?`)) {
    return;
  }

  try {
    const res = await authFetch(
      `${API}/api/master/departments/${dept.id}`,
      { method: "DELETE" }
    );

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error);
    }

    pushToast("Department deleted");

    setForm(f => ({
      ...f,
      department: "",
      categories: [],
      sub_category: ""
    }));

    loadMasterLists();
  } catch (err) {
    pushToast(err.message, "error");
  }
};

const deleteCategory = async () => {
  if (!form.categories.length) {
    pushToast("Select category", "error");
    return;
  }

  const cat = masterCategories.find(
    c => c.name === form.categories[0]
  );

  if (!cat) return;

  try {
    await authFetch(
      `${API}/api/master/categories/${cat.id}`,
      { method: "DELETE" }
    );

    pushToast("Category deleted");

    setForm(f => ({
      ...f,
      categories: [],
      sub_category: ""
    }));

    loadMasterLists();
  } catch {
    pushToast("Delete failed", "error");
  }
};
const deleteSubCategory = async () => {
  if (!form.sub_category) {
    pushToast("Select sub category", "error");
    return;
  }

  const sub = masterSubCategories.find(
    s => s.name === form.sub_category
  );

  if (!sub) return;

  try {
    await authFetch(
      `${API}/api/master/sub-categories/${sub.id}`,
      { method: "DELETE" }
    );

    pushToast("Sub Category deleted");

    setForm(f => ({
      ...f,
      sub_category: ""
    }));

    loadMasterLists();
  } catch {
    pushToast("Delete failed", "error");
  }
};



  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.contact_person || !form.contact_number || !form.email ||
        !form.address_line1 || !form.address_line2 || !form.department || form.categories.length === 0) {
      pushToast("Please fill all mandatory master fields", "error");
      return;
    }
    try {
      if (editingId) {
        await authFetch(`${API}/vendors/${editingId}`, {
          method: "PUT", headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        });
        pushToast("Vendor updated");
      } else {
        await authFetch(`${API}/add-vendor`, {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        });
        pushToast("Vendor added");
      }
      resetForm(); setShowForm(false);
      await loadVendors();
    } catch { pushToast("Something went wrong", "error"); }
  };

  const doDelete = async () => {
    const id = confirmDel; setConfirmDel(null);
    try {
      await authFetch(`${API}/vendors/${id}`, { method: "DELETE" });
      pushToast("Vendor deleted");
      await loadVendors();
    } catch { pushToast("Failed to delete", "error"); }
  };

  const handleEdit = (v) => {
    setForm({
      name: v.name || "", gst_no: v.gst_no || "",
      contact_person: v.contact_person || "", contact_number: v.contact_number || "",
      email: v.email || "", department: v.department || "", categories: v.categories || [],
      sub_category: v.sub_category || "", source: v.source || "", 
      address_line1: v.address_line1 || "", address_line2: v.address_line2 || "",
      address_line3: v.address_line3 || "",
    });
    setEditingId(v.id); setShowForm(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  useEffect(() => {

  const editId = searchParams.get("edit");

  if (!editId || vendors.length === 0) return;

  const vendor = vendors.find(
    v => String(v.id) === String(editId)
  );

  if (vendor) {
    handleEdit(vendor);
  }

}, [vendors, searchParams]);

  const viewSummary = async (v) => {
    setSummaryVendor(v);
    try {
      const res = await authFetch(`${API}/vendor-summary/${v.id}`);
      setSummary(await res.json());
    } catch { setSummary({ total_orders: 0, total_amount: 0 }); }
  };

  const exportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filtered);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Vendors");
    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), "vendors.xlsx");
    pushToast("Excel exported");
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(16); doc.text("Vendor List", 14, 18);
    doc.setFontSize(10); doc.text(`Generated: ${new Date().toLocaleString()}`, 14, 25);
    autoTable(doc, {
      startY: 32,
      head: [["ID", "Vendor", "Department", "Contact", "Source", "Category", "Sub-Cat"]], 
      body: filtered.map((v) => [
        v.id, 
        v.name,
        v.department || "-",
        v.contact_person, 
        v.source || "-", 
        (v.categories || []).join(", "),
        v.sub_category || "-"
      ]),
      styles: { fontSize: 9 }, headStyles: { fillColor: [24, 24, 27] },
    });
    doc.save(`vendors_${Date.now()}.pdf`);
    pushToast("PDF exported");
  };

  const filtered = useMemo(() => {
    let result = vendors;

    if (selectedDeptFilter) {
      result = result.filter((v) => v.department === selectedDeptFilter.value);
    }

    if (selectedCategoryFilter) {
      result = result.filter((v) =>
        v.categories?.some((c) => c.toLowerCase() === selectedCategoryFilter.value.toLowerCase())
      );
    }

    if (selectedSourceFilter) {
      result = result.filter((v) =>
        v.source?.toLowerCase() === selectedSourceFilter.value.toLowerCase()
      );
    }

    const text = search.toLowerCase();
    if (text) {
      result = result.filter((v) =>
        v.name?.toLowerCase().includes(text) ||
        v.contact_person?.toLowerCase().includes(text) ||
        v.department?.toLowerCase().includes(text) ||
        v.sub_category?.toLowerCase().includes(text) ||
        v.email?.toLowerCase().includes(text) ||
        v.categories?.some((c) => c.toLowerCase().includes(text))
      );
    }

    return result;
  }, [vendors, search, selectedDeptFilter, selectedCategoryFilter, selectedSourceFilter]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / itemsPerPage));
  const safePage = Math.min(currentPage, totalPages);
  const currentData = filtered.slice((safePage - 1) * itemsPerPage, safePage * itemsPerPage);

  const s = {
    page: { minHeight: "100vh", background: t.bg, color: t.text,
      fontFamily:"'Inter','IBM Plex Sans',sans-serif",
      padding: "32px 24px", transition: "background .2s,color .2s" },
    wrap: {width: "100%", position: "relative"},
    header: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 28, flexWrap: "wrap", gap: 12 },
    logoBox: { width: 44, height: 44, borderRadius: 14,
      background: dark ? "linear-gradient(135deg,#fff,#a1a1aa)" : "linear-gradient(135deg,#18181b,#3f3f46)",
      color: dark ? "#09090b" : "#fff", display: "flex", alignItems: "center", justifyContent: "center",
      boxShadow: dark ? "0 8px 24px rgba(255,255,255,.06)" : "0 8px 24px rgba(0,0,0,.12)" },
    h1: { margin: 0, fontSize: 24, fontWeight: 700, letterSpacing: "-0.02em" },
    sub: { margin: "2px 0 0", fontSize: 13, color: t.textMuted },
    iconBtn: { width: 40, height: 40, borderRadius: 12, border: `1px solid ${t.border}`,
      background: t.card, color: t.text, cursor: "pointer",
      display: "flex", alignItems: "center", justifyContent: "center", transition: "all .15s" },
    primaryBtn: { height: 40, padding: "0 18px", borderRadius: 12, border: "none",
      background: t.primary, color: t.primaryText, cursor: "pointer", fontSize: 13.5, fontWeight: 600,
      display: "flex", alignItems: "center", gap: 8,
      boxShadow: dark ? "0 4px 14px rgba(255,255,255,.08)" : "0 4px 14px rgba(0,0,0,.15)" },
    
    controlRow: { display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, marginBottom: 20, flexWrap: "wrap" },
    toolbarLeft: { display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap", flex: 1 },
    
    miniStatCard: { background: t.surface, border: `1px solid ${t.border}`, borderRadius: 12,
      padding: "0 16px", height: 44, backdropFilter: "blur(20px)", WebkitBackdropFilter: "blur(20px)",
      display: "flex", alignItems: "center", gap: 10 },
    statLabel: { fontSize: 11, fontWeight: 600, letterSpacing: "0.04em", textTransform: "uppercase", color: t.textMuted },
    statValue: { fontSize: 16, fontWeight: 800, color: t.text },

    section: { background: t.surface, border: `1px solid ${t.border}`, borderRadius: 18,
      backdropFilter: "blur(20px)", WebkitBackdropFilter: "blur(20px)", overflow: "hidden", marginBottom: 16 },
    sectionHead: { display: "flex", justifyContent: "space-between", alignItems: "center",
      padding: "16px 24px", borderBottom: `1px solid ${t.borderSoft}` },
    formGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))", gap: 16, padding: 24 },
    fieldLabel: { display: "block", fontSize: 11, fontWeight: 600, letterSpacing: "0.08em",
      textTransform: "uppercase", color: t.textMuted, marginBottom: 6 },
    input: { width: "100%", height: 44, borderRadius: 11, border: `1px solid ${t.border}`,
      background: t.inputBg, color: t.text, padding: "0 14px", fontSize: 14,
      outline: "none", transition: "all .15s", boxSizing: "border-box" },
    
    searchBox: { display: "flex", alignItems: "center", gap: 10,
      background: t.card, border: `1px solid ${t.border}`, borderRadius: 12,
      padding: "0 14px", height: 44, width: 220, maxWidth: "100%" },
    searchInput: { flex: 1, border: "none", outline: "none", background: "transparent",
      color: t.text, fontSize: 14 },
    
    filterBox: { width: 200, maxWidth: "100%" },
    
    ghostBtn: { height: 44, padding: "0 16px", borderRadius: 12,
      border: `1px solid ${t.border}`, background: t.card, color: t.text,
      cursor: "pointer", fontSize: 13, fontWeight: 500,
      display: "flex", alignItems: "center", gap: 8, transition: "all .15s" },
    table: { width: "100%", borderCollapse: "collapse", minWidth: 1000 },
    th: { padding: "14px 24px", textAlign: "left", fontSize: 11, fontWeight: 600,
      letterSpacing: "0.08em", textTransform: "uppercase", color: t.textMuted,
      borderBottom: `1px solid ${t.borderSoft}`,
      background: dark ? "rgba(0,0,0,0.2)" : "rgba(250,250,250,0.6)" },
    td: { padding: "14px 24px", verticalAlign: "top", borderBottom: `1px solid ${t.borderSoft}`, fontSize: 14 },
    avatar: { width: 36, height: 36, borderRadius: 10,
      background: dark ? "linear-gradient(135deg,#fff,#a1a1aa)" : "linear-gradient(135deg,#18181b,#3f3f46)",
      color: dark ? "#09090b" : "#fff",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontWeight: 700, fontSize: 13, flexShrink: 0 },
    idChip: { fontFamily: "monospace", fontSize: 12, padding: "3px 8px", borderRadius: 6,
      background: t.chip, color: t.chipText },
    gstChip: { fontFamily: "monospace", fontSize: 12, padding: "4px 10px", borderRadius: 7,
      border: `1px solid ${t.border}`, background: t.chip, color: t.chipText },
    sourceChip: { fontSize: 12, fontWeight: 600, padding: "4px 10px", borderRadius: 7,
      border: `1px solid ${t.border}`, background: t.chip, color: t.textMuted }, 
    catChip: { fontSize: 11.5, fontWeight: 500, padding: "3px 10px", borderRadius: 999,
      border: `1px solid ${t.border}`, background: t.card, color: t.text },
    rowBtn: { width: 34, height: 34, borderRadius: 9, border: `1px solid ${t.border}`,
      background: t.card, color: t.text, cursor: "pointer",
      display: "inline-flex", alignItems: "center", justifyContent: "center",
      marginLeft: 4, transition: "all .15s" },
    rowBtnDanger: { color: t.danger },
    pageBtn: (active) => ({ minWidth: 34, height: 34, padding: "0 12px", borderRadius: 9,
      border: `1px solid ${active ? t.primary : t.border}`,
      background: active ? t.primary : t.card,
      color: active ? t.primaryText : t.text,
      cursor: "pointer", fontSize: 13, fontWeight: 600, transition: "all .15s" }),
    footer: { textAlign: "center", marginTop: 24, color: t.textFaint, fontSize: 12 },
  };

  const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 56,
    height: 56,
    borderRadius: 14,
    fontSize: 15,
    background: t.inputBg,
    borderColor: state.isFocused ? t.primary : t.border,
    boxShadow: state.isFocused
      ? `0 0 0 3px ${
          dark ? "rgba(255,255,255,.08)" : "rgba(0,0,0,.06)"
        }`
      : "none",
    "&:hover": {
      borderColor: state.isFocused ? t.primary : t.border,
    },
  }),

  valueContainer: (base) => ({
    ...base,
    padding: "0 12px",
    display: "flex",
    alignItems: "center",
  }),

  placeholder: (base) => ({
    ...base,
    color: t.textFaint,
    fontSize: 15,
  }),

  singleValue: (base) => ({
    ...base,
    color: t.text,
    fontSize: 15,
    fontWeight: 500,
  }),

  input: (base) => ({
    ...base,
    color: t.text,
    fontSize: 15,
  }),

  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: t.border,
  }),

  dropdownIndicator: (base) => ({
    ...base,
    color: t.textMuted,
  }),

  clearIndicator: (base) => ({
    ...base,
    color: t.textMuted,
  }),

  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),

  menu: (base) => ({
    ...base,
    background: t.card,
    border: `1px solid ${t.border}`,
    borderRadius: 14,
    overflow: "hidden",
    zIndex: 9999,
    boxShadow: dark
      ? "0 10px 30px rgba(0,0,0,.35)"
      : "0 10px 30px rgba(0,0,0,.12)",
  }),

  menuList: (base) => ({
    ...base,
    maxHeight: 350,
    paddingTop: 8,
    paddingBottom: 8,
  }),

  option: (base, state) => ({
    ...base,
    padding: "16px 20px",
    fontSize: 15,
    fontWeight: 600,
    lineHeight: "22px",
    backgroundColor: state.isFocused
      ? dark
        ? "#374151"
        : "#f3f4f6"
      : "transparent",
    color: t.text,
    cursor: "pointer",
  }),

  multiValue: (base) => ({
    ...base,
    background: t.chip,
    borderRadius: 8,
    padding: "2px 4px",
  }),

  multiValueLabel: (base) => ({
    ...base,
    color: t.text,
    fontWeight: 500,
  }),
  valueContainer: (base) => ({
  ...base,
  height: 56,
  padding: "0 12px",
}),

placeholder: (base) => ({
  ...base,
  color: t.textFaint,
  fontSize: 15,
  margin: 0,
}),
multiValue: (base) => ({
  ...base,
  background: t.chip,
  borderRadius: 8,
  margin: 2,
}),

multiValueLabel: (base) => ({
  ...base,
  fontSize: 13,
  fontWeight: 500,
}),

indicatorsContainer: (base) => ({
  ...base,
  height: 56,
}),

  multiValueRemove: (base) => ({
    ...base,
    color: t.textMuted,
    ":hover": {
      background: t.border,
      color: t.text,
    },
  }),
};

  return (
    <div style={s.page}>
      <style>{`
        @keyframes fadeIn { from{opacity:0} to{opacity:1} }
        @keyframes slideIn { from{opacity:0;transform:translateY(-10px)} to{opacity:1;transform:translateY(0)} }
        @keyframes slideRight { from{transform:translateX(20px);opacity:0} to{transform:translateX(0);opacity:1} }
        .vp-row:hover { background:${t.rowHover} !important; }
        .vp-iconBtn:hover { background:${t.chip} !important; border-color:${t.textMuted} !important; }
        .vp-rowBtn:hover { background:${t.chip} !important; transform:translateY(-1px); }
        .vp-rowBtnDanger:hover { background:${dark ? "rgba(244,63,94,.12)" : "#fef2f2"} !important; border-color:${t.danger} !important; }
        .vp-primary:hover { transform:translateY(-1px); }
        .vp-input:focus { border-color:${t.primary} !important; box-shadow:0 0 0 3px ${dark ? "rgba(255,255,255,.08)" : "rgba(0,0,0,.06)"} !important; }
        .vp-ghost:hover { background:${t.chip} !important; }
        .vp-overlay { background:rgba(0,0,0,.5); backdrop-filter:blur(4px); }
        ::-webkit-scrollbar { width:10px; height:10px; }
        ::-webkit-scrollbar-thumb { background:${t.border}; border-radius:8px; }
      `}</style>

      {/* Toast */}
      {toast && (
        <div style={{ position: "fixed", top: 24, right: 24, zIndex: 100,
          display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", borderRadius: 12,
          background: toast.type === "error" ? (dark ? "#3f1d1d" : "#fef2f2") : (dark ? "#0c2920" : "#ecfdf5"),
          border: `1px solid ${toast.type === "error" ? t.danger : t.success}`, color: toast.type === "error" ? t.danger : t.success,
          boxShadow: "0 10px 30px rgba(0,0,0,.15)", animation: "slideIn .25s ease-out", fontSize: 13.5, fontWeight: 500 }}>
          {toast.msg}
        </div>
      )}

      {/* Confirm dialog */}
      {confirmDel != null && (
        <div className="vp-overlay" style={{ position: "fixed", inset: 0, zIndex: 90, display: "flex", alignItems: "center", justifyContent: "center", animation: "fadeIn .18s" }}>
          <div style={{ background: t.card, border: `1px solid ${t.border}`, borderRadius: 18, padding: 28, width: "92%", maxWidth: 420, boxShadow: "0 20px 60px rgba(0,0,0,.3)" }}>
            <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>Delete vendor?</h3>
            <p style={{ margin: "8px 0 22px", fontSize: 14, color: t.textMuted }}>This will permanently remove the vendor record. This action cannot be undone.</p>
            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
              <button onClick={() => setConfirmDel(null)} style={s.ghostBtn} className="vp-ghost">Cancel</button>
              <button onClick={doDelete} style={{ ...s.primaryBtn, background: t.danger, color: "#fff" }}>Delete</button>
            </div>
          </div>
        </div>
      )}

      {/* Summary drawer */}
      {summary && (
        <div className="vp-overlay" onClick={() => { setSummary(null); setSummaryVendor(null); }} style={{ position: "fixed", inset: 0, zIndex: 80, display: "flex", justifyContent: "flex-end", animation: "fadeIn .18s" }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: t.card, borderLeft: `1px solid ${t.border}`, width: "100%", maxWidth: 440, height: "100%", padding: 28, overflowY: "auto", animation: "slideRight .25s ease-out" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <div>
                <p style={{ margin: 0, fontSize: 11, letterSpacing: "0.1em", textTransform: "uppercase", color: t.textMuted, fontWeight: 600 }}>Vendor History</p>
                <h3 style={{ margin: "6px 0 0", fontSize: 20, fontWeight: 700 }}>{summaryVendor?.name || "Summary"}</h3>
              </div>
              <button onClick={() => { setSummary(null); setSummaryVendor(null); }} style={s.iconBtn} className="vp-iconBtn">{Icon.close}</button>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginTop: 24 }}>
              <div style={{ background: t.chip, borderRadius: 14, padding: 18 }}>
                <p style={{ margin: 0, fontSize: 12, color: t.textMuted }}>Orders</p>
                <p style={{ margin: "6px 0 0", fontSize: 26, fontWeight: 700 }}>{summary.total_orders ?? 0}</p>
              </div>
              <div style={{ background: t.chip, borderRadius: 14, padding: 18 }}>
                <p style={{ margin: 0, fontSize: 12, color: t.textMuted }}>Amount</p>
                <p style={{ margin: "6px 0 0", fontSize: 26, fontWeight: 700 }}>₹{Number(summary.total_amount ?? 0).toLocaleString("en-IN")}</p>
              </div>
            </div>
            {summaryVendor && (
              <div style={{ marginTop: 20, padding: 18, borderRadius: 14, background: t.chip, display: "flex", flexDirection: "column", gap: 10, fontSize: 13.5, color: t.text }}>
                <div>🏢 Dept: {summaryVendor.department || "—"}</div>
                <div>👤 {summaryVendor.contact_person}</div>
                <div>📞 {summaryVendor.contact_number}</div>
                <div>✉️ {summaryVendor.email}</div>
                {summaryVendor.source && <div>🌐 Source: {summaryVendor.source}</div>}
                <div>📍 {[summaryVendor.address_line1, summaryVendor.address_line2, summaryVendor.address_line3].filter(Boolean).join(", ")}</div>
              </div>
            )}
          </div>
        </div>
      )}

      <div style={s.wrap}>
        {/* HEADER */}
        <div style={s.header}>
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <div style={s.logoBox}>{Icon.building}</div>
            <div>
              <h1 style={s.h1}>Vendors Terminal</h1>
              <p style={s.sub}>Manage and monitor company vendor assets across core business segments</p>
            </div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={() => setDark(!dark)} style={s.iconBtn} className="vp-iconBtn" title="Toggle theme">{dark ? Icon.sun : Icon.moon}</button>
            <button onClick={() => { resetForm(); setShowForm(!showForm); }} style={s.primaryBtn} className="vp-primary">{showForm ? Icon.close : Icon.plus}{showForm ? "Close" : "Add Vendor"}</button>
          </div>
        </div>

        {/* FORM */}
        {showForm && (
          <div style={s.section}>
            <div style={s.sectionHead}>
              <div>
                <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>{editingId ? "Modify Vendor Records" : "Register New Vendor Portfolio"}</h2>
                <p style={{ margin: "2px 0 0", fontSize: 12, color: t.textMuted }}>Fields marked with * are required parameters</p>
              </div>
              <button onClick={() => { resetForm(); setShowForm(false); }} style={s.iconBtn} className="vp-iconBtn">{Icon.close}</button>
            </div>
            <div
  style={{
    maxHeight: "70vh",
    overflowY: "auto"
  }}
>
<form onSubmit={handleSubmit} style={s.formGrid}>
              {[
                ["name", "Vendor Name *", "Vendor name"],
                ["contact_person", "Contact Person Name *", "Full Name"],
                ["contact_number", "Contact No *", "Phone Number"],
                ["email", "Corporate Email Address *", "mail@gmail.com"],
                ["gst_no", "GST Registration ID", "15-Digit GSTIN Number"],
              ].map(([n, l, p]) => (
                <div key={n}>
                  <label style={s.fieldLabel}>{l}</label>
                  <input name={n} placeholder={p} value={form[n] || ""} onChange={handleChange} style={s.input} className="vp-input" />
                </div>
              ))}

              {/* DEPARTMENT SELECT */}
              <div>
                <label style={s.fieldLabel}>Department *</label>
               <CreatableSelect
               components={{
  Option: DepartmentOption
}}
               isClearable
formatCreateLabel={(inputValue) =>
  `Create "${inputValue}"`
}
  options={masterDepartments.map(d => ({
  id: d.id,
  value: d.name,
  label: d.name
}))}
  placeholder="Select Department..."
  menuPortalTarget={document.body}
  menuPosition="fixed"
  value={
    form.department
      ? {
          value: form.department,
          label: form.department
        }
      : null
  }
  onChange={(sel) =>
    setForm((f) => ({
      ...f,
      department: sel ? sel.value : "",
      categories: [],
      sub_category: ""
    }))
  }
onCreateOption={async (inputValue) => {
  console.log("CREATE DEPARTMENT:", inputValue);
    try {
      const res = await authFetch(
        `${API}/api/master/departments`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            name: inputValue
          })
        }
      );

      const newDept = await res.json();

      setMasterDepartments((prev) => [
        ...prev,
        newDept
      ]);

      setForm((f) => ({
        ...f,
        department: inputValue
      }));

      pushToast("Department saved");
    } catch (err) {
      pushToast(
        "Failed to save department",
        "error"
      );
    }
  }}
  styles={selectStyles}
/>

              </div>

              {/* CATEGORY SELECT - FILTERED BY SELECTED DEPARTMENT */}
              <div>
                <label style={s.fieldLabel}>Category *</label>
                <CreatableSelect
                components={{
  Option: CategoryOption
}}
  isMulti
  options={dynamicCategoryFormOptions}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  styles={selectStyles}
  placeholder="Select Categories..."
  value={dynamicCategoryFormOptions.filter((o) =>
    form.categories.includes(o.value)
  )}
  onChange={(sel) =>
    setForm((f) => ({
      ...f,
      categories: sel ? sel.map((x) => x.value) : [],
      sub_category: ""
    }))
  }
  onCreateOption={async (inputValue) => {
  try {
    const res = await authFetch(`${API}/api/master/categories`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name: inputValue, department: form.department }),
    });
    const newCategory = await res.json();
    
    // Update master list with the ID returned from your Database
    setMasterCategories((prev) => [...prev, newCategory]);
    setForm((f) => ({ ...f, categories: [...f.categories, inputValue] }));
    pushToast("Category saved to database");
  } catch (err) {
    pushToast("Failed to save category", "error");
  }
}}
/>

              </div>

              {/* SUB-CATEGORY SELECT - FILTERED BY SELECTED CATEGORIES */}
              <div>
                <label style={s.fieldLabel}>Sub-Category</label>
                <CreatableSelect
  options={dynamicSubCategoryOptions}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  styles={selectStyles}
  placeholder="Select Sub-Category..."
  value={
    form.sub_category
      ? {
          value: form.sub_category,
          label: form.sub_category
        }
      : null
  }
  onChange={(sel) =>
    setForm((f) => ({
      ...f,
      sub_category: sel ? sel.value : ""
    }))
  }
  onCreateOption={async (inputValue) => {
  // Assuming you want to link it to the first category selected
  const parentCat = masterCategories.find(c => c.name === form.categories[0]);
  
  try {
    const res = await authFetch(`${API}/api/master/sub-categories`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ 
        name: inputValue, 
        category_id: parentCat?.id 
      }),
    });
    const newSub = await res.json();
    
    setMasterSubCategories((prev) => [...prev, newSub]);
    setForm((f) => ({ ...f, sub_category: inputValue }));
    pushToast("Sub-category saved to database");
  } catch (err) {
    pushToast("Failed to save sub-category", "error");
  }
}}
  styles={selectStyles}
/>

              </div>

              {/* Vendor Source Dropdown Input */}
              <div>
                <label style={s.fieldLabel}>Vendor Source</label>
                <CreatableSelect
                  isClearable
                  options={sources}
                  placeholder="Select or type new..."
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  value={form.source ? { value: form.source, label: form.source } : null}
                  onChange={(sel) => setForm((f) => ({ ...f, source: sel ? sel.value : "" }))}
                  onCreateOption={(inputValue) => {
                    const newOpt = { value: inputValue, label: inputValue };
                    setSources((prev) => [...prev, newOpt]);
                    setForm((f) => ({ ...f, source: inputValue }));
                  }}
                  styles={selectStyles}
                />
              </div>

              {[
                ["address_line1", "Address Core Line 1 *", "Street / Building / Plot No."],
                ["address_line2", "Address Core Line 2 *", "Area / Landmark / Sector"],
                ["address_line3", "State / Hub Coordinates", "City / Pincode / Region"],
              ].map(([n, l, p]) => (
                <div key={n}>
                  <label style={s.fieldLabel}>{l}</label>
                  <input name={n} placeholder={p} value={form[n] || ""} onChange={handleChange} style={s.input} className="vp-input" />
                </div>
              ))}

              <div style={{ gridColumn: "1 / -1", display: "flex", gap: 10, marginTop: 4 }}>
                <button type="submit" style={s.primaryBtn} className="vp-primary">{Icon.save}{editingId ? "Update Registry" : "Execute Entry"}</button>
                {editingId && <button type="button" onClick={() => { resetForm(); setShowForm(false); }} style={s.ghostBtn} className="vp-ghost">Cancel Changes</button>}
              </div>
            </form>
            </div>
          </div>
        )}

        {/* INTERACTION CONTROLS ROW */}
        <div style={s.controlRow}>
          <div style={s.toolbarLeft}>
            {/* Search Parameter */}
            <div style={s.searchBox}>
              <span style={{ color: t.textMuted, display: "flex" }}>{Icon.search}</span>
              <input style={s.searchInput} placeholder="Search records..." value={search} onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }} />
              {search && <button onClick={() => setSearch("")} style={{ background: "none", border: "none", color: t.textMuted, cursor: "pointer", padding: 0, display: "flex" }}>{Icon.close}</button>}
            </div>

            {/* Department Dropdown Filter */}
            <div style={s.filterBox}>
              <Select
                options={masterDepartments.map(d => ({ value: d.name, label: d.name }))}
                isClearable
                placeholder="Dept Filter"
                value={selectedDeptFilter}
                onChange={(option) => { setSelectedDeptFilter(option); setSelectedCategoryFilter(null); setCurrentPage(1); }}
                styles={selectStyles}
              />
            </div>

            {/* Category Dropdown Filter */}
            <div style={s.filterBox}>
              <Select
                options={dynamicCategoryFilterOptions}
                isClearable
                placeholder="Category Filter"
                value={selectedCategoryFilter}
                onChange={(option) => { setSelectedCategoryFilter(option); setCurrentPage(1); }}
                styles={selectStyles}
              />
            </div>

            {/* Source Dropdown Filter */}
            <div style={s.filterBox}>
              <Select
                options={sources}
                isClearable
                placeholder="Source Filter"
                value={selectedSourceFilter}
                onChange={(option) => { setSelectedSourceFilter(option); setCurrentPage(1); }}
                styles={selectStyles}
              />
            </div>

            {/* Metric Badge */}
            <div style={s.miniStatCard}>
              <span style={s.statLabel}>Matching:</span>
              <span style={s.statValue}>{filtered.length}</span>
            </div>
          </div>

          {!isPurchaseUser() && (
  <div style={{ display: "flex", gap: 8 }}>
    <button
      onClick={exportPDF}
      style={s.ghostBtn}
      className="vp-ghost"
    >
      {Icon.pdf} PDF
    </button>

    <button
      onClick={exportExcel}
      style={s.ghostBtn}
      className="vp-ghost"
    >
      {Icon.excel} Excel
    </button>
  </div>
)}
        </div>

        {/* TABLE */}
        <div style={{ ...s.section, marginBottom: 0 }}>
          <div style={{ overflowX: "auto" }}>
            <table style={s.table}>
              <thead>
                <tr>
                  <th style={s.th}>ID</th>
                  <th style={s.th}>Vendor Name</th>
                  <th style={s.th}>Department</th>
                  <th style={s.th}>Communications Matrix</th>
                  <th style={s.th}>Source</th> 
                  <th style={s.th}>Category & Sub-Cat</th>
                  <th style={s.th}>Address</th>
                  <th style={{ ...s.th, textAlign: "right" }}>System Controls</th>
                </tr>
              </thead>
              <tbody>
                {currentData.length === 0 ? (
                  <tr><td colSpan="8" style={{ padding: "60px 24px", textAlign: "center", color: t.textMuted }}> 
                    <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
                      <div style={{ width: 48, height: 48, borderRadius: 14, background: t.chip, display: "flex", alignItems: "center", justifyContent: "center", color: t.textFaint }}>{Icon.building}</div>
                      <p style={{ margin: 0, fontWeight: 600, color: t.text }}>No tracking vendor models match criteria</p>
                      <p style={{ margin: 0, fontSize: 12 }}>Modify search fields, clear structural category/source filters, or append safe records.</p>
                    </div>
                  </td></tr>
                ) : currentData.map((v) => (
                  <tr key={v.id} className="vp-row" style={{ transition: "background .15s" }}>
                    <td style={s.td}><span style={s.idChip}>#{v.id}</span></td>
                    <td style={s.td}>
                      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <div style={s.avatar}>{v.name?.[0]?.toUpperCase() || "?"}</div>
                        <div>
                          <div style={{ fontWeight: 600, color: t.text }}>{v.name}</div>
                          <div style={{ fontSize: 11, color: t.textMuted, marginTop: 2 }}>GST: {v.gst_no || "—"}</div>
                        </div>
                      </div>
                    </td>
                    <td style={s.td}><span style={{ fontWeight: 600, color: t.text }}>{v.department || "—"}</span></td>
                    <td style={s.td}>
                      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                        <span style={{ fontWeight: 500 }}>{v.contact_person}</span>
                        <span style={{ fontSize: 12, color: t.textMuted, display: "flex", alignItems: "center", gap: 5 }}>{Icon.phone} {v.contact_number}</span>
                        <span style={{ fontSize: 12, color: t.textMuted, display: "flex", alignItems: "center", gap: 5 }}>{Icon.mail} {v.email}</span>
                      </div>
                    </td>
                    <td style={s.td}><span style={s.sourceChip}>{v.source || "—"}</span></td> 
                    <td style={s.td}>
                      <div style={{ display: "flex", flexDirection: "column", gap: 6, maxWidth: 220 }}>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                          {(v.categories || []).map((cat, i) => <span key={i} style={s.catChip}>{cat}</span>)}
                        </div>
                        {v.sub_category && (
                          <div style={{ fontSize: 12, color: t.textMuted }}>
                            ↳ Sub: <strong style={{ color: t.text }}>{v.sub_category}</strong>
                          </div>
                        )}
                      </div>
                    </td>
                    <td style={s.td}>
                      <div style={{ display: "flex", alignItems: "flex-start", gap: 6, maxWidth: 240, fontSize: 13, color: t.textMuted, lineHeight: 1.5 }}>
                        <span style={{ marginTop: 3, color: t.textFaint, flexShrink: 0 }}>{Icon.pin}</span>
                        <span>{[v.address_line1, v.address_line2, v.address_line3].filter(Boolean).join(", ")}</span>
                      </div>
                    </td>
                    
                    <td style={{ ...s.td, textAlign: "right", whiteSpace: "nowrap" }}>
                     <button
  onClick={() => handleEdit(v)}
  style={s.rowBtn}
  className="vp-rowBtn"
>
  {Icon.edit}
</button>
                      <button onClick={() => viewSummary(v)} style={s.rowBtn} className="vp-rowBtn" title="Financial Log Ledger">{Icon.history}</button>
                      {!isPurchaseUser() && (
  <button
    onClick={() => setConfirmDel(v.id)}
    style={{ ...s.rowBtn, ...s.rowBtnDanger }}
    className="vp-rowBtnDanger"
  >
    {Icon.trash}
  </button>
)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* PAGINATION */}
          {filtered.length > 0 && (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 24px", borderTop: `1px solid ${t.borderSoft}`, flexWrap: "wrap", gap: 10 }}>
              <p style={{ margin: 0, fontSize: 12, color: t.textMuted }}>
                Displaying entries <strong style={{ color: t.text }}>{(safePage - 1) * itemsPerPage + 1}</strong>{" – "}<strong style={{ color: t.text }}>{Math.min(safePage * itemsPerPage, filtered.length)}</strong>{" of internal index "}<strong style={{ color: t.text }}>{filtered.length}</strong>
              </p>
              <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                <button disabled={safePage === 1} onClick={() => setCurrentPage((p) => Math.max(1, p - 1))} style={{ ...s.pageBtn(false), opacity: safePage === 1 ? 0.4 : 1, cursor: safePage === 1 ? "not-allowed" : "pointer" }}>{Icon.chevL}</button>
                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter((n) => n === 1 || n === totalPages || Math.abs(n - safePage) <= 1)
                  .map((n, idx, arr) => (
                    <span key={n} style={{ display: "flex", alignItems: "center" }}>
                      {idx > 0 && arr[idx - 1] !== n - 1 && <span style={{ padding: "0 4px", color: t.textFaint }}>…</span>}
                      <button onClick={() => setCurrentPage(n)} style={s.pageBtn(safePage === n)}>{n}</button>
                    </span>
                  ))}
                <button disabled={safePage === totalPages} onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))} style={{ ...s.pageBtn(false), opacity: safePage === totalPages ? 0.4 : 1, cursor: safePage === totalPages ? "not-allowed" : "pointer" }}>{Icon.chevR}</button>
              </div>
            </div>
          )}
        </div>

        <p style={s.footer}>{filtered.length} indexed agent matrix node{filtered.length === 1 ? "" : "s"} • Verified System Cycle {new Date().toLocaleDateString()}</p>
      </div>
    </div>
  );
}

export default VendorsPage;